var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "buy" },
    [
      _c("div", { staticClass: "buy-top" }, [
        _c(
          "div",
          {
            staticClass: "member-cards pr",
            style:
              "background:url(" +
              _vm.detail.bg +
              ")  no-repeat;color:" +
              _vm.detail.colorText
          },
          [
            _c("div", { staticClass: "cards-top flex pr" }, [
              _c("img", { attrs: { src: _vm.detail.icon, alt: "等级图标" } }),
              _c("div", { staticClass: "cards-top-con" }, [
                _c("h3", [_vm._v(_vm._s(_vm.detail.vipName))])
              ])
            ])
          ]
        )
      ]),
      _c(
        "van-cell-group",
        { staticClass: "buy-member", attrs: { border: false } },
        [
          _c("van-cell", {
            attrs: { title: "会员分类", value: _vm.detail.name }
          }),
          _c("van-cell", {
            attrs: { title: "会员金额" },
            scopedSlots: _vm._u([
              {
                key: "right-icon",
                fn: function() {
                  return [
                    _c("span", { staticClass: "members-price" }, [
                      _vm._v("￥" + _vm._s(_vm.totalPice))
                    ])
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _c("h4", [_vm._v("请选择支付方式")]),
      _c(
        "van-cell-group",
        { staticClass: "buy-member", attrs: { border: false } },
        [
          _c("van-cell", {
            attrs: { title: "会员分类" },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function() {
                  return [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/imgs/members/wx.png"),
                        alt: "微信"
                      }
                    }),
                    _c("span", { staticClass: "custom-title" }, [
                      _vm._v("微信支付")
                    ])
                  ]
                },
                proxy: true
              },
              {
                key: "right-icon",
                fn: function() {
                  return [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.selectPay("payWx")
                          }
                        }
                      },
                      [
                        _vm.payWx
                          ? _c("img", {
                              attrs: {
                                src: require("@/assets/imgs/members/buy-checked.png"),
                                alt: "选中"
                              }
                            })
                          : _c("img", {
                              attrs: {
                                src: require("@/assets/imgs/members/uncheck.png"),
                                alt: "未选中"
                              }
                            })
                      ]
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _c("van-cell", {
            attrs: { title: "会员金额" },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function() {
                  return [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/imgs/members/wallet.png"),
                        alt: "微信"
                      }
                    }),
                    _c("span", { staticClass: "custom-title" }, [
                      _vm._v("钱包余额支付")
                    ]),
                    _c("label", [_vm._v("(" + _vm._s(_vm.myWallet) + "元)")])
                  ]
                },
                proxy: true
              },
              {
                key: "right-icon",
                fn: function() {
                  return [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.selectPay("payWallet")
                          }
                        }
                      },
                      [
                        _vm.payWallet
                          ? _c("img", {
                              attrs: {
                                src: require("@/assets/imgs/members/buy-checked.png"),
                                alt: "选中"
                              }
                            })
                          : _c("img", {
                              attrs: {
                                src: require("@/assets/imgs/members/uncheck.png"),
                                alt: "未选中"
                              }
                            })
                      ]
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _c("div", { staticClass: "flex service" }, [
        _c("div", { on: { click: _vm.selectService } }, [
          _vm.isAgree
            ? _c("img", {
                attrs: {
                  src: require("@/assets/imgs/members/xz.png"),
                  alt: "未选中"
                }
              })
            : _c("img", {
                attrs: {
                  src: require("@/assets/imgs/members/uncheck.png"),
                  alt: "选中"
                }
              })
        ]),
        _c("span", [
          _vm._v("我已阅读并同意 "),
          _c("a", { attrs: { href: _vm.proUrl } }, [
            _vm._v("《会员服务开通协议》")
          ])
        ])
      ]),
      _c("div", { staticClass: "footer tc" }, [
        _c("button", { on: { click: _vm.submit } }, [_vm._v("支付")])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }